var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock alert, timer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.46967 4.71967C1.17678 5.01256 1.17678 5.48744 1.46967 5.78033C1.76256 6.07322 2.23744 6.07322 2.53033 5.78033L5.53033 2.78033C5.82322 2.48744 5.82322 2.01256 5.53033 1.71967C5.23744 1.42678 4.76256 1.42678 4.46967 1.71967L1.46967 4.71967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5303 1.71967C19.2374 1.42678 18.7626 1.42678 18.4697 1.71967C18.1768 2.01256 18.1768 2.48744 18.4697 2.78033L21.4697 5.78033C21.7626 6.07322 22.2374 6.07322 22.5303 5.78033C22.8232 5.48744 22.8232 5.01256 22.5303 4.71967L19.5303 1.71967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9999 12C21.9999 17.5228 17.5227 22 11.9999 22C6.47704 22 1.99989 17.5228 1.99989 12C1.99989 6.47715 6.47704 2 11.9999 2C17.5227 2 21.9999 6.47715 21.9999 12ZM11.9999 7C12.4141 7 12.7499 7.33579 12.7499 7.75V11.6893L15.2802 14.2197C15.5731 14.5126 15.5731 14.9874 15.2802 15.2803C14.9873 15.5732 14.5125 15.5732 14.2196 15.2803L11.4696 12.5303C11.3289 12.3897 11.2499 12.1989 11.2499 12V7.75C11.2499 7.33579 11.5857 7 11.9999 7Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.c9187fbdadea1f5c49fa221559d76cf2.svg";
export { ForwardRef as ReactComponent };